import React from "react";
import styled from "styled-components";
import { Grid } from "@material-ui/core";
import numberFormatter from "utils/numberFormatter";

const CalculatedValueWrapper = styled(Grid)`
& {
  font-size:17px;
}
`;
const ResultsWrapper = styled(Grid)`
& {
  text-align: right;
}
`;
const ViewValue = styled.span`
  padding-left:12px;
`;
const Currency = ({ value }) => (
  <ViewValue>{numberFormatter.formatMoney(value)}</ViewValue>
);
const Rate = ({ value, decimalCount, placeholder, shouldNotMultiply }) => (
  <ViewValue>{numberFormatter.formatRate(value, decimalCount, placeholder, shouldNotMultiply)}</ViewValue>
);
const Integer = ({ value }) => (
  <ViewValue>{numberFormatter.formatWholeNumber(value)}</ViewValue>
);
const Decimal = ({ value, decimalCount, placeholder, shouldNotMultiply }) => (
  <ViewValue>{numberFormatter.formatDecimal(value, decimalCount, placeholder, shouldNotMultiply)}</ViewValue>
);

export const CalculatedCurrency = ({ label, value, placeholder }) => {
  let renderedValue = placeholder || <ViewValue>-</ViewValue>;
  if (!isNaN(value)) {
    renderedValue = <Currency value={value} />;
  }

  return (
    <CalculatedValueWrapper container item>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}><span>{label}</span></Grid>
      <ResultsWrapper item xs={2} sm={2} md={2} lg={2} xl={2}>{renderedValue}</ResultsWrapper>
    </CalculatedValueWrapper>
  );
};

export const CalculatedRate = ({ label, value, placeholder, decimalCount }) => {
  let renderedValue = placeholder || <ViewValue>-</ViewValue>;
  if (!isNaN(value)) {
    renderedValue = (
      <Rate
        value={value}
        decimalCount={decimalCount}
        placeholder={placeholder}
        shouldNotMultiply
      />
    );
  }

  return (
    <CalculatedValueWrapper container item>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}><span>{label}</span></Grid>
      <ResultsWrapper item xs={2} sm={2} md={2} lg={2} xl={2}>{renderedValue}</ResultsWrapper>
    </CalculatedValueWrapper>
  );
};

export const CalculatedInteger = ({ label, value, placeholder, min }) => {
  let renderedValue = placeholder || <ViewValue>-</ViewValue>;
  if (!isNaN(value) && min !== undefined) {
    renderedValue = <Integer value={Math.max(value, min)} />;
  } else if (!isNaN(value)) {
    renderedValue = <Integer value={value} />;
  }

  return (
    <CalculatedValueWrapper container item>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}><span>{label}</span></Grid>
      <ResultsWrapper item xs={2} sm={2} md={2} lg={2} xl={2}>{renderedValue}</ResultsWrapper>
    </CalculatedValueWrapper>
  );
};

export const CalculatedDecimal = ({ label, value, placeholder, decimalCount }) => {
  let renderedValue = placeholder || <ViewValue>-</ViewValue>;
  if (!isNaN(value)) {
    renderedValue = (
      <Decimal
        value={value}
        decimalCount={decimalCount}
        placeholder={placeholder}
        shouldNotMultiply
      />
    );
  }

  return (
    <CalculatedValueWrapper container item>
      <Grid item xs={3} sm={3} md={3} lg={3} xl={3}><span>{label}</span></Grid>
      <ResultsWrapper item xs={2} sm={2} md={2} lg={2} xl={2}>{renderedValue}</ResultsWrapper>
    </CalculatedValueWrapper>
  );
};
